<template>
  <div class="text-center">
    <v-dialog v-model="isOpen" max-width="1000">
      <v-card :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`">
        <v-card-title class="font-weight-bold">
          <div>{{ i18n.submission_requests  + ' | ' }}<span class="font-weight-light">{{ resource ? i18n.edit : i18n.add }}</span></div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="submission.type"
                :rules="[rules.required]"
                label="Type"
                :items="types"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field :rules="[rules.required]" v-model="submission.request" label="Request" outlined dense />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="submission.request"
                outlined
                v-if="submission.type == 'text'"
                autocomplete="disabled"
                dense
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                v-model="submission.submission"
              ></v-text-field>

              <v-text-field
                :label="submission.request"
                outlined
                autocomplete="disabled"
                dense
                @keypress="isNumber($event)"
                v-if="submission.type == 'number'"
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                v-model="submission.submission"
              ></v-text-field>

              <v-textarea
                :label="submission.request"
                outlined
                autocomplete="disabled"
                dense
                v-if="submission.type == 'textarea'"
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                v-model="submission.submission"
              ></v-textarea>

              <v-switch
                v-if="submission.type == 'switch'"
                :label="submission.request"
                outlined
                autocomplete="disabled"
                dense
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                v-model="submission.submission"
              ></v-switch>

              <UploadFile
                v-if="submission.type == 'upload'"
                :label="submission.request"
                prefix="documents"
                :modelValue="submission.submission"
                @update:modelValue="(value) => (submission.submission = value)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="isOpen = false">
            Close
          </v-btn>
          <v-btn color="success" :disabled="!isValid()" text @click="$emit('saveResource', submission)">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadFile from "../uploadFile.vue";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    resource: Object,
  },
  data() {
    return {
      submission: {
        type: null,
        request: null,
        submission: null,
      },
      types: [
        { text: "Text", value: "text" },
        { text: "Number", value: "number" },
        { text: "Textarea", value: "textarea" },
        { text: "Switch", value: "switch" },
        { text: "Upload", value: "upload" },
      ],
      rules: {
        required: (value) => !!value || this.i18n["required"],
        email: (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n["valid_email"],
      },
    };
  },
  watch: {
    resource: {
      handler(value) {
        if (value) {
          this.submission = { ...value };
        } else {
          this.submission = {
            type: null,
            request: null,
            submission: null,
          };
        }
      },
      deep: true,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("closeDialog");
      },
    },
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    isValid() {
      const { type, request } = this.submission;
      return type && request;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 && !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  components: { UploadFile },
};
</script>
